import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const MessagesSmallFill = (props: SvgIconT.Props) => (
  <SvgIcon width={12} height={13} {...props} viewBox="0 0 12 13">
    <g transform="translate(-1756.000000, -147.000000)">
      <path d="M1758,147.5 L1766,147.5 C1767.10457,147.5 1768,148.395431 1768,149.5 L1768,157.5 C1768,158.604569 1767.10457,159.5 1766,159.5 L1758,159.5 C1756.89543,159.5 1756,158.604569 1756,157.5 L1756,149.5 C1756,148.395431 1756.89543,147.5 1758,147.5 Z"></path>
    </g>
  </SvgIcon>
);

export default MessagesSmallFill;
